import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import PropTypes from "prop-types"
import { getTeamMembers } from "@api/settings/organizations/members"
import { getTeamRoles } from "@api/settings/organizations/roles"
import { Button, Modal } from "@bitcine/cs-theme"
import AttachedUsers from "./attached_users"
import AddExistingUsers from "./add_existing_users"
import InviteNewUsers from "./invite_new_users"

const TeamMembersModal = ({ label = 'Team Access', onClose, getTeamMembers, getTeamRoles, ...props }) => {
  const [addUsers, setAddUsers] = useState(false)
  const [inviteUsers, setInviteUsers] = useState(false)
  useEffect(() => {
    // getTeamMembers()
    getTeamRoles()
  }, [])
  return (
    <Modal open title={label} width={3} onClose={onClose}>
      {addUsers
        ?  <AddExistingUsers {...props} onBack={() => setAddUsers(false)} />
        : inviteUsers
        ? <InviteNewUsers {...props} onBack={() => setInviteUsers(false)}/>
        : <>
            <AttachedUsers {...props}/>
            <div className='flex justify-end'>
              <Button className='mt1 white mr1' onClick={() => setInviteUsers(true)}>Invite users</Button>
              <Button className='mt1' onClick={() => setAddUsers(true)}>Add users from your organization</Button>
            </div>
          </>}
    </Modal>
  )
}

TeamMembersModal.propTypes = {
  label: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  getTeamMembers: PropTypes.func.isRequired,
  getTeamRoles: PropTypes.func.isRequired
}
const mapStateToProps = state => ({
  allUsers: state.settings.organizations.members.items,
})

const mapDispatchToProps = (dispatch) => ({
  getTeamMembers: bindActionCreators(getTeamMembers, dispatch),
  getTeamRoles: bindActionCreators(getTeamRoles, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(TeamMembersModal)